import jwtDecode from 'jwt-decode';

import { currentJwt } from '@src/utils/jwtHelpers';

const hotJar = () => {
    const decodedJWT = jwtDecode(currentJwt());
    if (decodedJWT && decodedJWT.access_level === 'admin') {
        return;
    }

    // eslint-disable-next-line max-params
    (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () {
            // eslint-disable-next-line prefer-rest-params
            (h.hj.q = h.hj.q || []).push(arguments);
        };

        h._hjSettings = { hjid: 180028, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        // eslint-disable-next-line max-statements-per-line
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

export default hotJar;
